const typographyActionExpansion = {
  action: 'Ações Geradas ',
  accountable: 'Responsáveis: ',
  deadline: 'Prazo: ',
  noAccountable: 'Sem responsável',
  action: "Ação: ",
  problem: "Problema: ",
};

export default typographyActionExpansion;
